var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoGd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 181.23 178.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:url(#linear-gradient-5);}.cls-6{fill:url(#linear-gradient-6);}.cls-7{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 87.67,
    y1: -2.23,
    x2: 91.9,
    y2: 232.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#2328eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#2342eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#2360eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#2373eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#237aeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#2391eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#23caeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#23cceb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 83.6,
    y1: 119.04,
    x2: 102.51,
    y2: -60.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#2328eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#232aeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#2332eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#2340eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#2353eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#236beb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#237aeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#23cceb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 23.64,
    y1: 104.07,
    x2: 22.41,
    y2: 34.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2328eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23cceb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 69.29,
    y1: 104.59,
    x2: 68.06,
    y2: 35.16,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 114.53,
    y1: 105.02,
    x2: 113.3,
    y2: 35.61,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 159.59,
    y1: 104.83,
    x2: 158.36,
    y2: 35.41,
    xlinkHref: "#linear-gradient-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M129.81,21.73h-81c-20.24,0-36.65,15.9-36.65,35.5v61.86c0,19.61,16.41,35.5,36.65,35.5a21.44,21.44,0,0,1,4.75.55c5.11,2.27,2.66,21.21,6.81,23.6a1.6,1.6,0,0,0,1.81-.17c3.29-2.79,19.24-23.35,25.94-23.61,4.74-.19,41.66,0,41.66,0,20.24,0,36.68-16.26,36.68-35.87V57.23C166.45,37.63,150,21.73,129.81,21.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M181.23,52.6,150.58,6.09A12.33,12.33,0,0,0,140,0H39.35a10,10,0,0,0-8.67,5.05L0,52.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M0,52.39c0,.06,0,.11,0,.17,0,13,10.18,23.5,22.73,23.5s22.72-10.52,22.72-23.5c0-.06,0-.11,0-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M45.65,52.39v.17c0,13,10.17,23.5,22.72,23.5S91.1,65.54,91.1,52.56c0-.06,0-.11,0-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M91.11,52.39c0,.06,0,.11,0,.17,0,13,10.07,23.5,22.5,23.5s22.5-10.52,22.5-23.5v-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M136.11,52.39c0,.06,0,.11,0,.17,0,13,10.11,23.5,22.57,23.5s22.56-10.52,22.56-23.5c0-.06,0-.11,0-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M90.32,116.05c-11.14,0-21.42-1-29.77-7.68-1.11-.9-2.27,1.09-1.45,2.48,7.15,12.1,18.19,21,30.5,21,12.62,0,23.75-9,30.84-21.84.41-.74,0-2.76-.63-2.3C111.55,114.25,101.27,116.05,90.32,116.05Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGd);
export default __webpack_public_path__ + "static/media/logo_gd.a125e63eb7a06bbdc6513bd93d1742ea.svg";
export { ForwardRef as ReactComponent };